/**
 * Global Footer — Privacy / Terms / Cookies links + Cookie preferences trigger.
 *
 * Rendered by Shell (every authed page) and by the legal-page chrome (anonymous +
 * authed). J-X13 § Required affordances + J-X14 § Required affordances.
 *
 * The Cookie preferences trigger opens the CookieConsentBanner re-entry modal
 * via a custom event (`bimassess:cookie-preferences`); the banner mounts at App
 * root and listens. This keeps the Footer agnostic of banner internals and
 * avoids context-plumbing for a single-shot UI affordance.
 *
 * Inv 14 — internal nav via <Link>; Inv 15 — Link from `@/components/ui` barrel.
 */

import type { ReactElement } from 'react';
import { Link } from '@/components/ui';

export const COOKIE_PREFERENCES_EVENT = 'bimassess:cookie-preferences';

function openCookiePreferences(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(COOKIE_PREFERENCES_EVENT));
}

export function Footer(): ReactElement {
  return (
    <footer
      role="contentinfo"
      className="mt-12 border-t border-line bg-bg-warm"
    >
      <div className="mx-auto flex max-w-page flex-wrap items-center justify-between gap-4 px-page-pad-x py-6">
        <p className="font-mono text-mono text-muted-2">
          © {new Date().getFullYear()} BIMAssess
        </p>
        <nav aria-label="Legal" className="flex flex-wrap items-center gap-5">
          <Link to="/legal/privacy" className="font-mono text-mono no-underline">
            Privacy
          </Link>
          <Link to="/legal/terms" className="font-mono text-mono no-underline">
            Terms
          </Link>
          <Link to="/legal/cookies" className="font-mono text-mono no-underline">
            Cookies
          </Link>
          <button
            type="button"
            onClick={openCookiePreferences}
            className="font-mono text-mono text-ink underline-offset-4 hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-l focus-visible:ring-offset-2"
          >
            Cookie preferences
          </button>
        </nav>
      </div>
    </footer>
  );
}
